import type { ReactElement } from "react";
import React, { forwardRef } from "react";

import { useInputContainerStore } from "../../../../helpers/common/CoreInputText/store/inputContainerStore";
import { Dropdown } from "../../../Dropdown";
import { SEARCH_DISPLAY_NAME } from "../../utils/core";
import { createDisplayNameForSearchElement } from "../../utils/getDisplayName";
import { SearchInputContainer } from "../InputContainer/SearchInputContainer";

import type { IDropdown } from "../../../Dropdown";
import type { IDropdownRef } from "../../../Dropdown/types";

interface ISearchDropdownProps
    extends Omit<
        IDropdown,
        "openMenuAfterFocus" | "focusToActiveElementAfterOpen" | "children"
    > {
    children: ReactElement;
}

export const SearchDropdown = forwardRef<IDropdownRef, ISearchDropdownProps>(
    ({ "data-tsid": tsid, children, ...props }, ref) => {
        const {
            ref: inputContainerRef,
            inputProps,
            style,
            className,
        } = useInputContainerStore();

        return (
            <Dropdown
                {...props}
                focusToActiveElementAfterOpen={false}
                openMenuAfterFocus={false}
                data-tsid={tsid}
                data-uikit={`${SEARCH_DISPLAY_NAME}.Dropdown`}
                ref={ref}
            >
                <Dropdown.Button
                    as={SearchInputContainer}
                    style={style}
                    className={className}
                    {...inputProps}
                    ref={inputContainerRef}
                />
                {children}
            </Dropdown>
        );
    },
);

SearchDropdown.displayName =
    createDisplayNameForSearchElement("InputContainer");
